"use client";

import { c as _c } from "react/compiler-runtime";
import EndedParticipationDrop from "@/components/waves/drops/participation/EndedParticipationDrop";
import OngoingParticipationDrop from "@/components/waves/drops/participation/OngoingParticipationDrop";
import type { ParticipationDropProps } from "@/components/waves/drops/participation/participationRenderer.types";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
export default function QuorumParticipationDrop(props) {
  const $ = _c(4);
  const {
    isVotingEnded
  } = useDropInteractionRules(props.drop);
  if (isVotingEnded) {
    let t0;
    if ($[0] !== props) {
      t0 = <EndedParticipationDrop {...props} contentPresentation="quorumCompact" />;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  let t0;
  if ($[2] !== props) {
    t0 = <OngoingParticipationDrop {...props} contentPresentation="quorumCompact" />;
    $[2] = props;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}